/** Helpers for master_containers.transport_type (same FK as containers). */

export const masterTransportTypeMatches = (
  masterTransportTypeId: number | null | undefined,
  containerTransportTypeId: number | null | undefined
): boolean => {
  if (masterTransportTypeId == null || containerTransportTypeId == null) {
    return false;
  }
  return masterTransportTypeId === containerTransportTypeId;
};

export const getMasterTransportTypeName = (
  master: {
    transport_type?: number | null;
    transport_type_info?:
      | { name?: string | null }
      | { name?: string | null }[]
      | null;
  } | null
    | undefined
): string => {
  const info = master?.transport_type_info;
  const single = Array.isArray(info) ? info[0] : info;
  return single?.name || "—";
};
